import { RealEstateDto } from "api/real-estate";
import { Button } from "components/ui/Button";
import { Divider } from "components/ui/Divider";
import { EyeIcon } from "components/icons/Icons";
import { FC } from "react";

interface TenantRealEstateCardProps {
  realEstate: RealEstateDto
  onEdit?: () => void
}

export const TenantRealEstateCard: FC<TenantRealEstateCardProps> = ({ realEstate, onEdit }) => {
  return (
    <div
      key={realEstate.id}
      className={`relative bg-white shadow rounded-xl overflow-hidden`}
    >
      {
        onEdit &&
        <div className="absolute right-2 top-2">
          <Button round color="slate" className="text-sm" onClick={onEdit}>
            <EyeIcon />
          </Button>
        </div>
      }
      {realEstate.photoUrl && (
        <img
          src={realEstate.photoUrl}
          alt={realEstate.name}
          className="w-full h-32 object-cover rounded"
          loading="lazy"
        />
      )}
      {!realEstate.photoUrl && (
        <img
          src={'/assets/images/real_estate_default.png'}
          alt={realEstate.name}
          className="w-full h-32 object-cover rounded"
          loading="lazy"
        />
      )}

      <div className="p-4">

        <h3 className="font-medium text-gray-900 mb-2">{realEstate.name}</h3>
        <div className="flex flex-col text-sm text-gray-600 mb-3">
          <span>{realEstate.address.line1}</span>
        </div>
        <Divider className="my-3" />
        <div className="flex items-center text-sm text-gray-600 mb-3">
          <div className="flex flex-col grow border-r">
            <span className="text-xl font-semibold text-gray-900">{realEstate.area} m²</span>
            <span className="text-gray-600">Superficie</span>
          </div>
          <div className="flex flex-col grow pl-4">
            <span className="text-xl font-semibold text-gray-900">{realEstate.roomCount}</span>
            <span className="text-gray-600">pièces</span>
          </div>
        </div>
        {
          realEstate.rentAmount &&
          <>
            <Divider className="my-3" />
            <div>
              <div className="text-xl font-semibold text-gray-900">
                {realEstate.rentAmount} €
                {realEstate.charges && (
                  <span className="text-lg font-normal text-gray-600"> + {realEstate.charges}€ CC</span>
                )}
              </div>
              <span className="font-normal text-gray-600">Loyer mensuel</span>
            </div>
          </>

        }
      </div>
    </div>
  )
}
